import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './layouts/header/header.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoginComponent } from './modules/login/login.component';

import {
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalModule,
  MsalRedirectComponent
} from '@azure/msal-angular';

import {
  PublicClientApplication,
  InteractionType
} from '@azure/msal-browser';
import { FormsModule } from '@angular/forms';

// Export MSAL PublicClientApplication instance to use in main.ts for initialization
export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: 'a3b2a75e-d054-4da5-9b74-966dcb2d3463',
    authority: 'https://login.microsoftonline.com/44060820-ecc9-4366-b97e-0db725e356db',
     redirectUri: environment.redirectUri,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  }
});
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    LoginComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
      FormsModule,
    MsalModule.forRoot(
      msalInstance,
      {
        interactionType: InteractionType.Popup,  // Use popup interaction
        authRequest: {
          scopes: ['https://graph.microsoft.com/Calendars.Read']
        }
      },
      {
        interactionType: InteractionType.Popup,  // Must match above interactionType
        protectedResourceMap: new Map([
          ['https://graph.microsoft.com/v1.0/me', ['https://graph.microsoft.com/Calendars.Read']],
          ['https://graph.microsoft.com/v1.0/me/calendar/events', ['https://graph.microsoft.com/Calendars.Read']]
        ])
      }
    )
  ],
  providers: [
    MsalGuard,
    MsalBroadcastService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    }
  ],
  bootstrap: [AppComponent, MsalRedirectComponent]  // Keep MsalRedirectComponent for redirect fallback
})
export class AppModule {}
